import FinancingIcon from '@material-ui/icons/AttachMoney';

import FinancingsList from './FinancingsList';
import FinancingsEdit from './FinancingsEdit';
import FinancingsCreate from './FinancingsCreate';

export default {
    list: FinancingsList,
    edit: FinancingsEdit,
    create: FinancingsCreate,
    icon: FinancingIcon,
};
